import { render, staticRenderFns } from "./seckill.vue?vue&type=template&id=253365ac&scoped=true&"
import script from "./seckill.vue?vue&type=script&lang=js&"
export * from "./seckill.vue?vue&type=script&lang=js&"
import style0 from "./seckill.vue?vue&type=style&index=0&id=253365ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253365ac",
  null
  
)

export default component.exports